import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'lib/translation';
import { TRANSLATE_FILE_PATH, VERSION } from './constants/AppConstants';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: TRANSLATE_FILE_PATH,
      queryStringParams: {
        v: VERSION, // Add VERSION to prevent caching
      },
    },
    whitelist: [
      'en', 'fr',
    ],
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
